// 高值采购申请表
import { Form } from "antd";
import { ApplicationInfoFormFields } from "./ApplicationInfoFormFields";
import { UserFormFields } from "@/components/UserFormFields/UserFormFields";
import type { PurchaseRequestFormProps } from "../../type";
import { BudgetInfoFormFields } from "./BudgetInfoFormFields";
import { ApplicantSubmittedDocumentsFormFields } from "./ApplicantSubmittedDocumentsFormFields";
import { useFormEditable } from "../../hooks/useFormEditable";
import { useModal } from "@/hooks/modals/useModal";
import { usePurchaseRequestDetail } from "../../hooks/usePurchaseRequest";
import { SourcingResultFormFields } from "./SourcingResultFormFields";
import { OrderConfrimFormFields } from "../OrderConfrimFormFields";
import {
  purchasingStaffFillInNodeCodesForHighOrLow,
  fillInPONodeCodes,
  createFixedAssetsNoNodeCodes,
} from "../../constant";
import { useExistFlowHistory } from "@/hooks/services/useFlow";
import { FixedAssetInfoFormFields } from "./FixedAssetInfoFormFields";

export const HighValuePurchaseRequisitionForm = ({
  form,
}: PurchaseRequestFormProps) => {
  const { props } = useModal("PURCHASE_REQUEST");
  const { recordId } = props;

  const detail = usePurchaseRequestDetail(recordId);

  const { isMainFormDisabled } = useFormEditable();
  const shouldShowSourcingResult = useExistFlowHistory(
    purchasingStaffFillInNodeCodesForHighOrLow,
    detail?.insId,
  );
  const shouldShowOrderConfirm = useExistFlowHistory(
    fillInPONodeCodes,
    detail?.insId,
  );
  const shouldShowFixedAssetsFields = useExistFlowHistory(
    createFixedAssetsNoNodeCodes,
    detail?.insId,
  );

  return (
    <Form layout="vertical" disabled={isMainFormDisabled} form={form}>
      <UserFormFields />
      {/* 申请信息 */}
      <ApplicationInfoFormFields />
      {/* 预算信息 */}
      <BudgetInfoFormFields />
      {/* 申请人提供文件 */}
      <ApplicantSubmittedDocumentsFormFields />

      {/* 寻源结果 */}
      {shouldShowSourcingResult && <SourcingResultFormFields />}

      {/* 固定资产信息 */}
      {shouldShowFixedAssetsFields && <FixedAssetInfoFormFields />}

      {/* 订单确认 */}
      {shouldShowOrderConfirm && <OrderConfrimFormFields />}
    </Form>
  );
};
